import { render } from "./ListMarriages.vue?vue&type=template&id=548eeaf7"
import script from "./ListMarriages.vue?vue&type=script&lang=js"
export * from "./ListMarriages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__